import { Stack, Typography } from '@mui/material';
import React from 'react';
import NotificationSettings from './NotificationSettings';

const Settings = () => {
    return (
        <>
            <Typography variant='h1'>Notification Settings</Typography>
            <NotificationSettings />
        </>
    );
};

export default Settings;
